import {API_URL, THEME_COLOR} from "../constant"
import React, { useEffect, useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import StepLabel from '@mui/material/StepLabel';
import Select from 'react-select';
import { Link } from "react-router-dom";
import banner1 from "../logo.svg"
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';

import toast, { Toaster } from 'react-hot-toast';
// import { Link } from "react-router-dom";


const MemberRegister = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [cities, setCities] = useState([]);
    const [banks, setBanks] = useState([]);
    const [sponsors, setSponsors] = useState([]);
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    const [formData, setFormData] = useState({
        "FirstName" : "",
        "LastName" : "",
        "Gender" : "",
        "IDNumber" : "",
        "BirthDate" : "",
        "Email" : "",
        "WhatsappNumber" : "",
        "MobileNumber" : "",
        "Address" : "",
        "City" : "",
        "PostalCode" : "",
        "Bank" : "",
        "AccountNumber" : "",
        "AccountName" : "",
        "Referal" : "",
        "ReferalID": "",
        "ReferalCode": "",
        "ReferalName": "",
    });
    
    async function RegisterUser(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("memberdata", JSON.stringify(formData));


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/memberjoin/register`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    const initForm = async ()=>{
        await initCity();
        await initBank();
        var elems = document.querySelectorAll('select');
        var instances = M.FormSelect.init(elems, {});
    }
    function fetchCity(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/city`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initCity(){
        let response = await fetchCity();
        if(response.status == 200){
            // setCities(response.data);
            // let select = document.getElementById("City");
            // select.innerHTML = "";
            // (response.data).forEach(element => {
            //     let option = document.createElement("option");
            //     option.value = element.ID
            //     option.text = element.Name
            //     select.append(option);
            // });
            let temp = [];
            (response.data).forEach(element => {
                temp.push({value: element.ID, label: element.Name});
            })
            setCities(temp);
        }
    }

    function fetchBank(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/bank`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initBank(){
        let response = await fetchBank();
        if(response.status == 200){
            // setCities(response.data);
            // let select = document.getElementById("Bank");
            // select.innerHTML = "";
            // (response.data).forEach(element => {
            //     let option = document.createElement("option");
            //     option.value = element.ID
            //     option.text = element.Abbreviation
            //     select.append(option);
            // });
            let temp = [];
            (response.data).forEach(element => {
                temp.push({value: element.ID, label: element.Abbreviation})
            })
            setBanks(temp);
        }
    }

    function updateFirstName(val){
        let copy = {...formData};
        copy["FirstName"] = val.target.value;
        copy["AccountName"] = (copy["FirstName"] + " " + copy["LastName"]).toUpperCase()
        setFormData(copy);
    }

    function updateLastName(val){
        let copy = {...formData};
        copy["LastName"] = val.target.value;
        copy["AccountName"] = (copy["FirstName"] + " " + copy["LastName"]).toUpperCase()
        setFormData(copy);
    }

    function updateGender(val){
        let copy = {...formData};
        copy["Gender"] = val;
        setFormData(copy);
    }

    function updateIDNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["IDNumber"] = result;
        setFormData(copy);
    }

    function updateBirthDate(val){
        let copy = {...formData};
        copy["BirthDate"] = val.target.value;
        setFormData(copy);
    }

    function updateEmail(val){
        let copy = {...formData};
        copy["Email"] = val.target.value;
        setFormData(copy);
    }

    function updateWhatsappNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["WhatsappNumber"] = result;
        setFormData(copy);
    }

    function updateMobileNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["MobileNumber"] = result;
        setFormData(copy);
    }

    function updateAddress(val){
        let copy = {...formData};
        copy["Address"] = val.target.value;
        setFormData(copy);
    }

    function updateCity(val){
        let copy = {...formData};
        copy["City"] = val;
        setFormData(copy);
    }

    function updatePostalCode(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["PostalCode"] = result;
        setFormData(copy);
    }

    function updateBank(val){
        let copy = {...formData};
        copy["Bank"] = val;
        setFormData(copy);
    }

    function updateSponsor(val){
        let copy = {...formData};
        copy["Referal"] = val;
        copy["ReferalID"] = val.value
        copy["ReferalCode"] = val.code;
        copy["ReferalName"] = val.name;
        setFormData(copy);
    }

    function updateAccountNumber(val){
        let copy = {...formData};
        let result = val.target.value;
        result = result.replace(/[^0-9]/g, '');
        copy["AccountNumber"] = result;
        setFormData(copy);
    }

    function updateAccountName(val){
        let copy = {...formData};
        copy["AccountName"] = (val.target.value).toUpperCase();
        setFormData(copy);
    }

    function updateReferalCode(val){
        let copy = {...formData};
        copy["ReferalCode"] = val.code;
        setFormData(copy);
    }

    function updateReferalName(val){
        let copy = {...formData};
        copy["ReferalName"] = val.label;
        setFormData(copy);
    }

    async function CheckUsername(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("username", username);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkusername`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function CheckEmail(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", email);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkemail`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }
    async function CheckPhone(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("phone", phone);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/register/checkphone`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error))
    }

    async function FormValidation(){
        let valid = true;

        let fields = ["FirstName", "LastName", "IDNumber", "Email", "WhatsappNumber","MobilePhone","Address","PostalCode","AccountNumber","AccountName"];
        // let fields = ["FirstName", "LastName", "IDNumber", "Email", "WhatsappNumber","MobilePhone","Address","PostalCode","AccountNumber","AccountName","ReferalCode","ReferalName"];
        
        fields.map((value)=>{
            let field = document.getElementById(value);
            console.log(value)
            if(!field || field.value == ""){
                document.getElementById(value+"Validation").setAttribute("data-error", "This field is required");
                field.classList.remove("valid");
                field.classList.add("invalid");
            }else{
                field.classList.remove("invalid");
                field.classList.add("valid");
            }
        })


        let countvalid = document.getElementsByClassName("invalid").length;
        valid = countvalid === 0;

        return valid;
    }

    async function SubmitHandler(event){
        event.preventDefault();
        let valid = await FormValidation();
        if(valid){
            let response = await RegisterUser();
            response = JSON.parse(response);
            if(response.status == 200){
                let copy = {...formData};
                copy["FirstName"] = "";
                copy["LastName"] = "";
                copy["IDNumber"] = "";
                copy["BirthDate"] = "";
                copy["Email"] = "";
                copy["WhatsappNumber"] = "";
                copy["MobileNumber"] = "";
                copy["Address"] = "";
                copy["PostalCode"] = "";
                copy["AccountNumber"] = "";
                copy["AccountName"] = "";
                setFormData(copy);
            }else{
                // console.log(response.message)
            }
            toast.error(response.message)
        }

    }

    function fetchSponsor(sponsorid){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/sponsor/${sponsorid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initSponsor(sponsorid){
        let response = await fetchSponsor(sponsorid);
        if(response.status == 200){
            let temp = [];
            (response.data).forEach(element => {
                updateSponsor({value: element.ID, label: element.Code, name: element.Name, code: element.Code});
                temp.push({value: element.ID, label: element.Code, name: element.Name, code: element.Code});
            })
            setSponsors(temp);
        }
    }

    useEffect(async ()=>{
        await initCity();
        await initBank();
        var elems = document.querySelectorAll('select');
        var instances = M.FormSelect.init(elems, {});
        let code = props.match.params.sponsorid;
        await initSponsor(code);
    },[])

    return(
        <React.StrictMode>
            <HeaderBack title="Register" /> 
            <div className="row" style={{padding:"10px", backgroundColor:"white"}}>
                <form className="col s12"><div className="row">
                    <h5>Member Information</h5>
                    </div>
                    <div className="row">
                        <div className="input-field col s6">
                            <input placeholder="First Name" id="FirstName" type="text" className="input-upper validate" required value={formData["FirstName"]} onChange={updateFirstName}/>
                            <label className="active" htmlFor="FirstName" data-error="wrong">First Name</label>
                            <span className="helper-text" id="FirstNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Last Name" id="LastName" type="text" className="input-upper validate" required value={formData["LastName"]} onChange={updateLastName} />
                            <label className="active" htmlFor="LastName">Last Name</label>
                            <span className="helper-text" id="LastNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            {/* <select className="form-control" id="Gender">
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                            </select> */}
                            <Select
                                options={
                                    [
                                        {value: "M", label: "Male"},
                                        {value: "F", label: "Female"},
                                    ]
                                }
                                value = {formData["Gender"]}
                                onChange = {updateGender}
                            ></Select>
                            {/* <label className="" htmlFor="Gender">Gender</label>
                            <span className="helper-text" id="GenderValidation" data-error="this field is required" data-success=""></span> */}
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="ID Number" id="IDNumber" type="text" className="validate" required value={formData["IDNumber"]} onChange={updateIDNumber}/>
                            <label className="active" htmlFor="IDNumber">ID Card Number</label>
                            <span className="helper-text" id="IDNumberValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <Stack spacing={3}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <MobileDatePicker
                                        label="Birth Date"
                                        value={formData["BirthDate"]}
                                        onChange={async (newValue) => {
                                            let copy = {...formData};               
                                            copy["BirthDate"] = newValue
                                            setFormData(copy);
                                        }}
                                        renderInput={(params) => <TextField {...params} helperText={null} />}
                                    />
                                </LocalizationProvider>
                            </Stack>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Email" id="Email" type="text" className="validate" required value={formData["Email"]} onChange={updateEmail}/>
                            <label className="active" htmlFor="Email">Email</label>
                            <span className="helper-text" id="EmailValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <input placeholder="08XXXXXXXXXX" id="WhatsappNumber" type="text" className="validate" required value={formData["WhatsappNumber"]} onChange={updateWhatsappNumber}/>
                            <label className="active" htmlFor="WhatsappNumber" data-error="wrong">Whatsapp Number</label>
                            <span className="helper-text" id="WhatsappNumberValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="08XXXXXXXXXX" id="MobilePhone" type="text" className="validate" required value={formData["MobileNumber"]} onChange={updateMobileNumber}/>
                            <label className="active" htmlFor="MobilePhone">Mobile Phone</label>
                            <span className="helper-text" id="MobilePhoneValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s12">
                            <textarea id="Address" className="materialize-textarea" required onChange={updateAddress} value={formData["Address"]}></textarea>
                            <label className="active" htmlFor="Address" data-error="wrong">Address</label>
                            <span className="helper-text" id="AddressValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <Select
                                options={cities}
                                value={formData["City"]}
                                onChange={updateCity}
                            ></Select>
                            {/* <select className="form-control" id="City">
                            </select>
                            <label className="" htmlFor="City">City</label>
                            <span className="helper-text" id="ProvinceValidation" data-error="this field is required" data-success=""></span> */}
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Postal Code" id="PostalCode" type="text" className="validate" required value={formData["PostalCode"]} onChange={updatePostalCode} />
                            <label className="active" htmlFor="PostalCode">Postal Code</label>
                            <span className="helper-text" id="PostalCodeValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <h5>Bank Information</h5>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            {/* <select className="form-control" id="Bank">
                                <option>Male</option>
                                <option>Female</option>
                            </select>
                            <label className="" htmlFor="Bank">Bank</label>
                            <span className="helper-text" id="BankValidation" data-error="this field is required" data-success=""></span> */}
                            <Select
                                options={banks}
                                value = {formData["Bank"]}
                                onChange = {updateBank}
                            ></Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <input placeholder="Account Number" id="AccountNumber" type="text" className="validate" required value={formData["AccountNumber"]} onChange={updateAccountNumber}  />
                            <label className="active" htmlFor="AccountNumber">Account Number</label>
                            <span className="helper-text" id="AccountNumberValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input placeholder="Account Name" id="AccountName" type="text" className="validate" required value={formData["AccountName"]} onChange={updateAccountName} />
                            <label className="active" htmlFor="AccountName">Account Name</label>
                            <span className="helper-text" id="AccountNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    
                    <div className="row">
                        <h5>Referral Information</h5>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            {/* <select className="form-control" id="Referal">
                                <option>ID100117457</option>
                                <option>ID100117557</option>
                            </select>
                            <label className="" htmlFor="Referal">Referal</label>
                            <span className="helper-text" id="ReferalValidation" data-error="this field is required" data-success=""></span> */}
                            <Select
                                options={sponsors}
                                value = {formData["Referal"]}
                                onChange = {updateSponsor}
                            ></Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="input-field col s6">
                            <input readOnly="true" placeholder="Referal Code" id="ReferalCode" type="text" className="validate" required value={formData["ReferalCode"]}/>
                            <label className="active" htmlFor="ReferalCode">Referal Code</label>
                            <span className="helper-text" id="ReferalCodeValidation" data-error="this field is required" data-success=""></span>
                        </div>
                        <div className="input-field col s6">
                            <input readOnly="true" placeholder="Referal Name" id="ReferalName" type="text" className="validate" required value={formData["ReferalName"]} />
                            <label className="active" htmlFor="ReferalName">Referal Name</label>
                            <span className="helper-text" id="ReferalNameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col s12 center">
                            <a className={`btn ${THEME_COLOR}`} onClick={SubmitHandler}><i></i>Register</a>
                        </div>
                    </div>
                </form>
            </div>
        </React.StrictMode>
    );
}

export default MemberRegister;
